const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7×24小时全天候监控全网热点，第一时间推送最新吃瓜动态，让你永远快人一步掌握一手资讯。',
  },
  {
    icon: 'ri-group-line',
    title: '万人互动',
    desc: '200万+活跃吃瓜群众实时在线讨论，每条热点都有真实评论和深度分析，吃瓜不再是一个人。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '真实爆料',
    desc: '严格的信源核实机制，聚合多方渠道信息交叉验证，拒绝虚假谣言，为吃瓜群众还原事件真相。',
  },
  {
    icon: 'ri-gift-line',
    title: '福利不断',
    desc: '定期举办吃瓜福利活动，从话题互动到幸运抽奖，让每一位吃瓜群众都有机会获得惊喜好礼。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          为什么200万吃瓜群众选择91吃瓜社区
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
                idx === 0 ? 'bg-primary-100 text-primary-500' :
                idx === 1 ? 'bg-accent-100 text-accent-500' :
                idx === 2 ? 'bg-secondary-100 text-secondary-500' :
                'bg-primary-100 text-primary-500'
              } group-hover:scale-110 transition-transform duration-300`}>
                <span className="w-6 h-6 flex items-center justify-center">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}